import React, { useEffect, useState } from "react";
import axios from "axios";
import API_URL from "../config";

const COLOR_PENDIENTE = "#2a78d6";
const COLOR_ATENDIDA = "#0ca30c";
const COLOR_NO_ASISTIO = "#fab219";
const COLOR_CANCELADA = "#ec835a";

const EstadisticasCDA = () => {
  const [servicios, setServicios] = useState([]);
  const [servicioId, setServicioId] = useState("");
  const [desde, setDesde] = useState("");
  const [hasta, setHasta] = useState("");
  const [datos, setDatos] = useState(null);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState("");
  const [hover, setHover] = useState(null);

  const token = localStorage.getItem("token");

  useEffect(() => {
    axios
      .get(`${API_URL}/api/servicios`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setServicios(res.data);
        if (res.data.length > 0) setServicioId(String(res.data[0].id));
      })
      .catch(() => setError("No se pudo cargar la lista de servicios."));
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!servicioId) return;
    setCargando(true);
    setError("");

    const params = {};
    if (desde) params.desde = desde;
    if (hasta) params.hasta = hasta;

    axios
      .get(`${API_URL}/api/citas/estadisticas/${servicioId}`, {
        headers: { Authorization: `Bearer ${token}` },
        params,
      })
      .then((res) => setDatos(res.data))
      .catch(() => setError("No se pudieron cargar las estadísticas de este servicio."))
      .finally(() => setCargando(false));
    // eslint-disable-next-line
  }, [servicioId, desde, hasta]);

  const filas = datos
    ? [
        {
          key: "pendiente",
          label: "Pendientes (agendadas)",
          valor: datos.conteo.pendiente,
          color: COLOR_PENDIENTE,
          detalle: null,
        },
        {
          key: "atendida",
          label: "Atendidas (realizadas)",
          valor: datos.conteo.atendida,
          color: COLOR_ATENDIDA,
          detalle: null,
        },
        {
          key: "no_asistio",
          label: "No asistió",
          valor: datos.conteo.no_asistio,
          color: COLOR_NO_ASISTIO,
          detalle: null,
        },
        {
          key: "cancelada",
          label: "Canceladas",
          valor: datos.conteo.cancelada_admin + datos.conteo.cancelada_profesor,
          color: COLOR_CANCELADA,
          detalle: `${datos.conteo.cancelada_admin} por administración · ${datos.conteo.cancelada_profesor} por el docente`,
        },
      ]
    : [];

  const maxValor = Math.max(...filas.map((f) => f.valor), 1);

  return (
    <div style={{ maxWidth: 920 }}>
      <h2 style={{ fontSize: 22, fontWeight: 700, marginBottom: 8, color: "#0b0b0b" }}>
        📊 Estadísticas de Citas
      </h2>
      <p style={{ color: "#52514e", marginBottom: 16 }}>
        Elegí el servicio para ver cuántas citas fueron agendadas, atendidas o canceladas.
      </p>

      <div style={{ display: "flex", gap: 12, flexWrap: "wrap", alignItems: "center", marginBottom: 12 }}>
        <select
          value={servicioId}
          onChange={(e) => setServicioId(e.target.value)}
          style={{
            padding: "8px 12px",
            borderRadius: 10,
            border: "1px solid #cbd5e1",
            fontSize: 14,
            minWidth: 280,
          }}
        >
          {servicios.map((s) => (
            <option key={s.id} value={s.id}>
              {s.nombre}
            </option>
          ))}
        </select>

        <label style={{ fontSize: 13, color: "#52514e", display: "flex", alignItems: "center", gap: 6 }}>
          Desde
          <input
            type="date"
            value={desde}
            onChange={(e) => setDesde(e.target.value)}
            style={{ padding: "7px 10px", borderRadius: 10, border: "1px solid #cbd5e1", fontSize: 14 }}
          />
        </label>

        <label style={{ fontSize: 13, color: "#52514e", display: "flex", alignItems: "center", gap: 6 }}>
          Hasta
          <input
            type="date"
            value={hasta}
            onChange={(e) => setHasta(e.target.value)}
            style={{ padding: "7px 10px", borderRadius: 10, border: "1px solid #cbd5e1", fontSize: 14 }}
          />
        </label>

        {(desde || hasta) && (
          <button
            onClick={() => {
              setDesde("");
              setHasta("");
            }}
            style={{
              padding: "7px 12px",
              borderRadius: 10,
              border: "1px solid #cbd5e1",
              background: "#fff",
              fontSize: 13,
              cursor: "pointer",
              color: "#52514e",
            }}
          >
            ✕ Limpiar fechas
          </button>
        )}
      </div>
      <div style={{ marginBottom: 16 }} />

      {cargando && <p>Cargando estadísticas...</p>}
      {error && <p style={{ color: "#d03b3b" }}>{error}</p>}

      {!cargando && !error && datos && (
        <div
          style={{
            maxWidth: 680,
            background: "#fcfcfb",
            border: "1px solid #e1e0d9",
            borderRadius: 16,
            padding: "28px 28px 20px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "baseline",
              gap: 10,
              marginBottom: 28,
            }}
          >
            <span style={{ fontSize: 40, fontWeight: 700, color: "#0b0b0b", lineHeight: 1 }}>
              {datos.total}
            </span>
            <span style={{ fontSize: 14, color: "#898781" }}>citas agendadas en total</span>
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
            {filas.map((f) => {
              const porcentaje = datos.total > 0 ? Math.round((f.valor / datos.total) * 100) : 0;
              const anchoBarra = Math.max((f.valor / maxValor) * 100, f.valor > 0 ? 3 : 0);
              const activo = hover === f.key;
              return (
                <div
                  key={f.key}
                  onMouseEnter={() => setHover(f.key)}
                  onMouseLeave={() => setHover(null)}
                  title={f.detalle || `${f.valor} de ${datos.total} citas (${porcentaje}%)`}
                  style={{ cursor: "default" }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "baseline",
                      marginBottom: 6,
                    }}
                  >
                    <span style={{ fontSize: 13, fontWeight: 600, color: "#0b0b0b" }}>
                      {f.label}
                    </span>
                    <span
                      style={{
                        fontSize: 13,
                        fontWeight: 700,
                        color: "#0b0b0b",
                        fontVariantNumeric: "tabular-nums",
                      }}
                    >
                      {f.valor}{" "}
                      <span style={{ fontWeight: 400, color: "#898781" }}>({porcentaje}%)</span>
                    </span>
                  </div>
                  <div
                    style={{
                      background: "#e1e0d9",
                      borderRadius: 999,
                      height: 10,
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        width: `${anchoBarra}%`,
                        background: f.color,
                        height: "100%",
                        borderRadius: 999,
                        opacity: activo ? 1 : 0.88,
                        transition: "width 0.4s ease, opacity 0.15s ease",
                      }}
                    />
                  </div>
                  {f.detalle && (
                    <div style={{ fontSize: 11, color: "#898781", marginTop: 4 }}>{f.detalle}</div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default EstadisticasCDA;
